import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import { changeModifierPosition } from "../../../store/Modifiers/api";
import { onModifiersLoad } from "../../../store/Modifiers/actions";

export const useChangeModifierPosition = ({ slug }) => {
    const dispatch = useDispatch();
    return useMutation(
        ["change-modifier-position", slug],
        ({ items }) => changeModifierPosition(items),
        {
            onSuccess: () => {
                dispatch(onModifiersLoad());
            },
        }
    );
};
